import { render, staticRenderFns } from "./Menulink.vue?vue&type=template&id=51500fd0&scoped=true"
import script from "./Menulink.vue?vue&type=script&lang=js"
export * from "./Menulink.vue?vue&type=script&lang=js"
import style0 from "./Menulink.vue?vue&type=style&index=0&id=51500fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51500fd0",
  null
  
)

export default component.exports